import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[additionalLegends-host]',
})

export class AdditionalLegendsDirective {
	constructor(public viewContainerRef: ViewContainerRef ) {}
}
